import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LIST_DONATE, MESSAGE } from '../../../utils/constants';
import { getDataNotify, formatDecimal, isTouch, getYoutubeId, getTiktokId } from '../../../utils/common';
import { withRouter } from 'react-router-dom';
import { changePoint } from '../../../actions/home/';
import { Button, Tooltip } from 'antd';
import TooltipUser from '../../../components/TooltipUser';
import Loading from '../../../components/Loading';
import { diamondVideoApi, donateVideoApi, getRankVideoApi } from '../../../api/video';
import { socket } from '../../../components/realtime/ReadSocketEvent';
import { showNotification, showNotificationBonus, showNotificationProperty, showNotificationAsset } from '../../../utils/notification';
import { updateCountMission } from '../../../actions/menu';
import { showModalEat } from '../../../actions/home/modalEat';
import { changeDataNewfeed } from '../../../actions/newfeed';
import Checked from '../../frame/Checked';

class Video extends Component {
    constructor(props) {
        super(props);
        this.state = {
            balanceDonate: LIST_DONATE[0],
            isPress: false,
            isLoadingRank: false,
            dataRank: {}
        }
    }

    renderDonate = () => {
        let { data } = this.props;
        let { balanceDonate, isPress } = this.state;
        return (
            <Tooltip
                overlayClassName='pv-tooltip-diamond'
                trigger={isTouch() ? 'click' : 'hover'}
                title={
                    <div className='flex-column item-center'>
                        <img
                            src={require('../../../assets/image/donate.png')}
                            className='avatar-guest'
                        />
                        <select
                            className='form-control mgt'
                            style={{ width: '75%' }}
                            defaultValue={balanceDonate}
                            onChange={e => this.setState({ balanceDonate: e.target.value })}
                        >
                            {LIST_DONATE.map((item, key) => (
                                <option key={key} value={item}>Tặng {formatDecimal(item)} $[z]</option>
                            ))}
                        </select>
                        <Button
                            className='pv-confirm-diamond'
                            style={{ marginTop: '10vh' }}
                            onClick={() => this.donateVideo(data.TargetId, balanceDonate, data.UserId, data.VideoDesc, data.NewfeedId)}
                            loading={isPress}
                        >
                            Tặng
                        </Button>
                        <div className='mgt' id={'notificationDonateVideo' + data.NewfeedId} />
                    </div>
                }
            >
                <img
                    src={require('../../../assets/image/donate.png')}
                    className='pv-donate-small'
                />
            </Tooltip>
        )
    }

    renderDiamond = () => {
        let { data, dataUser } = this.props;
        let { isPress } = this.state;
        if (!data.IsDiamond && data.DiamondQueue > 0) {
            return (
                <Tooltip
                    overlayClassName='pv-tooltip-diamond'
                    trigger={isTouch() ? 'click' : 'hover'}
                    title={
                        <div className='flex-column item-center'>
                            <img
                                src={require('../../../assets/image/diamond-white.gif')}
                                style={{ width: '8vh' }}
                            />
                            <Button
                                className='pv-confirm-diamond'
                                onClick={() => this.diamondVideo(data.TargetId, data.UserId, data.VideoDesc, data.NewfeedId)}
                                loading={isPress}
                            >
                                Bình chọn
                            </Button>
                            <div className='mgt' id={'notificationDiamondVideo' + data.NewfeedId} />
                        </div>
                    }
                >
                    <div className='flex-column item-center'>
                        <img
                            src={require('../../../assets/image/diamond-white.gif')}
                            className='pv-diamond'
                        />
                        <div className='count-diamond-remain'>
                            <p class="mgb-0 text-huge">{data.Diamond}</p>
                        </div>
                    </div>
                </Tooltip>
            )
        }
        return (
            <div className='flex-column item-center'>
                <img
                    src={require('../../../assets/image/diamond-disable.png')}
                    className='pv-diamond-disable'
                />
                <div className='count-diamond-remain'>
                    <p class="mgb-0 text-huge">{data.Diamond}</p>
                </div>
            </div>
        );
    }

    renderRank = () => {
        let { dataRank, isLoadingRank } = this.state;
        if (isLoadingRank) return (<Loading small />);
        return (
            <div className='row mgt-3'>
                <div className='col-md-6 col-xs-6 flex item-center'>
                    <div className='pv-rank-container'>
                        <Button className='button-pv-rank'>Hôm nay</Button>
                        <div className='flex-row item-center mgt-3'>
                            <p>{dataRank.diamondToday}</p>
                            <img
                                src={require('../../../assets/image/diamond-rank.png')}
                                className='pv-icon-rank'
                            />
                        </div>
                        <hr width="95%" align="center" className='hr-default' />
                        <div className='flex-row item-center'>
                            <p className='text-center'>{dataRank.rankDiamondToday}/{dataRank.allVideoToday}</p>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 col-xs-6 flex item-center'>
                    <div className='pv-rank-container'>
                        <Button className='button-pv-rank'>Trọn đời</Button>
                        <div className='flex-row item-center mgt-3'>
                            <p>{dataRank.diamondAll}</p>
                            <img
                                src={require('../../../assets/image/diamond-rank.png')}
                                className='pv-icon-rank'
                            />
                        </div>
                        <hr width="95%" align="center" className='hr-default' />
                        <div className='flex-row item-center'>
                            <p className='text-center'>{dataRank.rankDiamondAll}/{dataRank.allVideo}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    donateVideo = (videoId, balanceDonate, userPost, videoDesc, newfeedId) => {
        if (!this.state.isPress) {
            this.setState({ isPress: true });
            let idNotification = '#notificationDonateVideo' + newfeedId;
            balanceDonate = parseInt(balanceDonate);
            donateVideoApi(videoId, balanceDonate).then(res => {
                if (res.code == 1) {
                    let dataUser = this.props.dataUser;
                    //socket
                    if (userPost != dataUser.UserId) {
                        let datas = getDataNotify(userPost, 0, res.balanceBonus);
                        datas.message = {
                            fullName: dataUser.FullName,
                            facebookId: dataUser.FacebookId,
                            message: 'tặng ' + formatDecimal(balanceDonate) + ' $[z] cho video "' + videoDesc + '" của bạn',
                            isNotify: 2
                        }
                        socket.emit('send_notify', datas);
                    }
                    showNotificationBonus(balanceDonate, -1, 2);
                    showNotificationBonus(balanceDonate / 1000, 1, 5);
                    this.props.changePoint([null, -balanceDonate, null, null, balanceDonate / 1000]);
                    this.props.changeDataNewfeed(this.props.listNewfeed.map(el => {
                        if (el.NewfeedId == newfeedId) return Object.assign({}, el, {
                            Donate: parseInt(el.Donate) + balanceDonate
                        })
                        return el;
                    }));
                }
                showNotification(res.message, res.code, idNotification);
                this.setState({ isPress: false });
            }).catch(e => {
                this.setState({ isPress: false });
                showNotification(MESSAGE.ERROR, -1, idNotification);
            })
        }
    }

    diamondVideo = (videoId, userPost, videoDesc, newfeedId) => {
        if (!this.state.isPress) {
            this.setState({ isPress: true });
            let idNotification = '#notificationDiamondVideo' + newfeedId;
            diamondVideoApi(videoId, userPost).then((res) => {
                if (res.code == 1) {
                    showNotificationProperty(res.property);
                    showNotificationAsset(res.assetInfo);
                    showNotificationBonus(res.bonus.BalanceZ, 1, 3);
                    showNotificationBonus(res.bonus.Achievement, 1, 4);
                    this.props.changePoint([null, null, res.bonus.BalanceZ, res.bonus.Achievement, null, -res.diamondCount]);
                    this.props.updateCountMission('VideoDiamondCount');
                    //socket
                    let dataUser = this.props.dataUser;
                    let dataSent = getDataNotify(userPost, 0, 0, 0, res.bonus.Achievement, 0, res.propertyPa);
                    dataSent.DiamondCount = res.diamondCount;
                    dataSent.message = {
                        fullName: dataUser.FullName,
                        facebookId: dataUser.FacebookId,
                        message: 'bình chọn video "' + videoDesc + '" của bạn',
                        isNotify: 2
                    }
                    socket.emit('send_notify', dataSent);
                    //play sound
                    new Audio(require('../../../assets/audio/diamond.wav')).play();
                    this.props.changeDataNewfeed(this.props.listNewfeed.map(el => {
                        if (el.NewfeedType == 12) {
                            if (el.NewfeedId == newfeedId) {
                                return Object.assign({}, el, {
                                    IsDiamond: videoId,
                                    DiamondQueue: 0,
                                    Diamond: +el.Diamond + 1
                                });
                            }
                            return el;
                            // return Object.assign({}, el, {
                            //     DiamondQueue: 0
                            // });
                        }
                        return el;
                    }));
                    showNotification(res.message, res.code);
                }
                else {
                    if (res.code == -5) this.props.showModalEat(res.listFood);
                    else showNotification(res.message, res.code, idNotification);
                }
                this.setState({ isPress: false });
            }).catch(error => {
                showNotification(MESSAGE.ERROR, -1, idNotification);
                this.setState({ isPress: false });
            });
        }
    }

    getRankVideo = (videoId, userPost) => {
        let { dataRank, isLoadingRank } = this.state;
        if (Object.keys(dataRank).length === 0 && !isLoadingRank) {
            this.setState({ isLoadingRank: true });
            getRankVideoApi(videoId, userPost).then(res => {
                this.setState({
                    dataRank: res.data,
                    isLoadingRank: false
                });
            }).catch(e => {
                showNotification(MESSAGE.ERROR, 0);
                this.setState({
                    dataRank: {}
                });
            })
        }
    }

    render() {
        let data = this.props.data;
        return (
            <div>
                <div className='flex-row'>
                    <div>
                        <TooltipUser userInfo={data} avatarClass='avatar-guest' />
                    </div>
                    <div className='flex-column mgl-2'>
                        <p><span className='bold'>{data.FullName}
                            <Checked data={data} />
                        </span> chia sẻ nội dung chủ đề <span className='bold'>{data.CategoryName}</span></p>
                        <p className='silver'>{data.CrDateTime}</p>
                    </div>
                </div>
                <div className='pv-title-container'>
                    {data.IsDiamond ?
                        <img
                            src={require('../../../assets/image/diamond-white.gif')}
                            className='pv-diamond-case'
                        />
                        :
                        <img
                            src={require('../../../assets/image/diamond-case.png')}
                            className='pv-diamond-case'
                        />
                    }
                    <div className='flex-row mgt-2'>
                        <div className='flex-row flex-3 align-center'>
                            <p className='pv-check-p bg-success mgb-0'>Mã số: {data.TargetId}</p>
                        </div>
                        <div className='flex-row flex-2 align-center' style={{ justifyContent: 'flex-end' }}>
                            <div>
                                <img
                                    src={require('../../../assets/image/donate.png')}
                                    className='avatar-guest'
                                />
                            </div>
                            <div className='pv-donate-container'>
                                <p className='text-large bold'>{formatDecimal(data.Donate)} $[z]</p>
                            </div>
                        </div>
                    </div>
                    <p className='text-large text-center bold mgt mgb'>{data.VideoTitle}</p>
                    <div className='item-center'>
                        <img
                            src={require('../../../assets/image/line.png')}
                            className='line-img'
                        />
                    </div>
                    <div className='flex-row flex-3 item-center mgb mgt'>
                        <p className='pv-check-p mgb-0' style={{ background: 'rgba(0,0,0,0.85)' }}>Tôi chia sẻ video này vì: {data.VideoDesc}</p>
                    </div>
                    <div className='relative'>
                        <div className='blur-video' />
                        {data.VideoType == 2 ?
                            <div className='iframe-tiktok'>
                                <iframe
                                    scrolling="no"
                                    name="__tt_embed__v3802385945065390"
                                    sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin"
                                    src={`https://www.tiktok.com/embed/v2/${getTiktokId(data.VideoUrl)}?lang=vi&amp;`}
                                />
                            </div>
                            :
                            <iframe
                                className='mgt'
                                style={{ width: '100%', height: '60vh', borderRadius: '2vh' }}
                                src={"https://www.youtube.com/embed/" + getYoutubeId(data.VideoUrl)}
                                frameBorder="0"
                                allow="encrypted-media"
                                allowFullScreen="allowFullScreen"
                            />
                        }

                    </div>
                </div>
                {!data.Guest &&
                    <div className='flex-row mgt-4'>
                        <div className='flex-1 item-center'>
                            {this.renderDonate()}
                        </div>
                        <div className='flex-1 item-center'>
                            {this.renderDiamond()}
                        </div>
                        <div className='flex-1 item-center'>
                            <div className='flex-column item-center'>
                                <img
                                    src={require('../../../assets/image/flag-green.png')}
                                    className='pv-diamond'
                                />
                                <div className='count-diamond-remain'>
                                    <p class="mgb-0 text-huge">{data.Rank}/{data.AllVideo}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { dataUser } = state.getUserData;
    const { listNewfeed } = state.getListNewfeed;
    return { dataUser, listNewfeed };
}

export default connect(mapStateToProps, { changePoint, updateCountMission, showModalEat, changeDataNewfeed })(withRouter(Video));